<div class="label-color-optional">
    <cds-icon
        #colorIcon
        *ngIf="labelData.color"
        shape="stop"
        class="label-color-optional__color-icon"
        size="12"
    ></cds-icon>
    <span
        class="label-color-optional__placeholder"
        *ngIf="!labelData.color && labelData.forceAlign"
    ></span>
    <div>{{ labelData.label }}</div>
    <ng-content></ng-content>
</div>
